import { Layout, EditSitePlan as EditSitePlanComponent } from "components"
export const EditSitePlan = () => {
 return (
  <Layout>
   <EditSitePlanComponent />
  </Layout>
 )
}
